import React, { useContext, useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive';
import { Col, Container, Row, Spinner, Tab, Tabs } from 'react-bootstrap';
import { AuthContext, ThemeContext } from '../../../auth';
import { HeaderNotif, SidebarComponent, TabsPcpPenjualanDark, TabsPcpPenjualanLight, TabsPcpSewaDark, TabsPcpSewaLight } from '../../../components';
import Swal from 'sweetalert2';
import { axiosAuth } from '../../../api';

function PcpList() {

    const { theme } = useContext(ThemeContext);
    const { showSidebar, accessToken } = useContext(AuthContext);
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const [loading, setLoading] = useState(true);
    const [listPcpPenjualan, setListPcpPenjualan] = useState([]);
    const [listPcpSewa, setListPcpSewa] = useState([]);

    const retrievePcpPenjualan = () => {
        setLoading(true);
        axiosAuth.get(`/api/pcp`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                const filterData = res.data.data.filter(item => item.status === "pending" && item.lead?.status != 0);

                setListPcpPenjualan(filterData);

                setLoading(false);
            }).catch(err => {
                console.error(err);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memuat data, coba kembali beberapa saat lagi!',
                });

                setLoading(false);
            })
    };

    const retrievePcpSewa = () => {
        setLoading(true);
        axiosAuth.get(`/api/pcp/sewa`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                const filterData = res.data.data.filter(item => item.status === "pending" && item.lead?.status != 0);

                setListPcpSewa(filterData);

                setLoading(false);
            }).catch(err => {
                console.error(err);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memuat data, coba kembali beberapa saat lagi!',
                });

                setLoading(false);
            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrievePcpPenjualan();
        if (accessToken !== undefined) retrievePcpSewa();
    }, [accessToken]);

    return (
        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }}>
            <SidebarComponent />
            <div id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                style={{
                    width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '78px' : '190px'})`,
                    marginLeft: isMobile ? '0px' : showSidebar ? '78px' : '190px',
                    transition: '0.8s'
                }}
            >
                <div className={isMobile ? 'ms-2' : 'ms-3 me-1'}>
                    <Row>
                        <Col xs={6} lg={6} className='text-start'>
                            <h3 className='pt-4' style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '25px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                PCP
                            </h3>
                        </Col>
                        <Col xs={6} lg={6} className={isMobile === false ? 'text-end my-auto' : 'text-end my-auto pt-4'}>
                            <HeaderNotif />
                        </Col>
                    </Row>
                </div>
                <br />
                <br />
                {loading ? (
                    <div
                        className='d-flex justify-content-center align-items-center'
                        style={{ height: '200px' }}
                    >
                        <Spinner animation='border' style={{ color: theme === 'light' ? '#F3C623' : '#2f4b7c' }} />
                    </div>
                ) : (
                    <div className={isMobile ? 'mx-1' : 'mx-3'}>
                        <Tabs
                            id="controlled-tab-pcp"
                            defaultActiveKey="pcp-penjualan"
                            fill
                            style={{ fontFamily: 'Poppins-Regular' }}
                        >
                            <Tab eventKey="pcp-penjualan" title="PCP Penjualan">
                                <TabsPcpPenjualanDark
                                    retrievePcpPenjualan={retrievePcpPenjualan}
                                    listPcpPenjualan={listPcpPenjualan}
                                    accessToken={accessToken}
                                />
                            </Tab>
                            <Tab eventKey="pcp-sewa" title="PCP Sewa">
                                <TabsPcpSewaDark
                                    retrievePcpSewa={retrievePcpSewa}
                                    listPcpSewa={listPcpSewa}
                                    accessToken={accessToken}
                                />
                            </Tab>
                        </Tabs>
                    </div>
                )}
            </div>
        </div>
    )
}

export default PcpList
